// Paginador de listas largas. Vive acá y no dentro de una pantalla porque lo usan la
// base de email marketing y los usuarios del sistema de puntos, y dos copias del mismo
// paginador se desincronizan en cuanto se toca una.

// Números de página a mostrar: siempre la primera, la última y las vecinas de la actual.
// Con 40 páginas, listarlas todas sería otro muro de botones.
export function paginasVisibles(actual, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const s = new Set([1, total, actual, actual - 1, actual + 1]);
  const nums = [...s].filter(n => n >= 1 && n <= total).sort((a, b) => a - b);
  const out = [];
  nums.forEach((n, i) => {
    if (i > 0 && n - nums[i - 1] > 1) out.push('…');
    out.push(n);
  });
  return out;
}

export default function Paginador({ actual, total, onIr }) {
  if (total <= 1) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, flexWrap: 'wrap', marginTop: 14 }}>
      <button className="lb-btn lb-btn--ghost lb-btn--sm" disabled={actual === 1} onClick={() => onIr(Math.max(1, actual - 1))}>← Anterior</button>
      {paginasVisibles(actual, total).map((n, i) => (
        n === '…'
          ? <span key={'g' + i} style={{ color: 'var(--ink-600)', padding: '0 4px' }}>…</span>
          : <button key={n} onClick={() => onIr(n)}
              className={'lb-btn lb-btn--sm ' + (n === actual ? 'lb-btn--white' : 'lb-btn--ghost')}
              style={{ minWidth: 38 }}>{n}</button>
      ))}
      <button className="lb-btn lb-btn--ghost lb-btn--sm" disabled={actual === total} onClick={() => onIr(Math.min(total, actual + 1))}>Siguiente →</button>
    </div>
  );
}
